<template>
  <Modal
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    max-width="max-w-[520px]"
    @close="handleClose"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary text-left">Reprovar registro</h2>
    </template>

    <div class="flex flex-col gap-4">
      <v-autocomplete
        v-model="selectedReason"
        :items="rejectionReasonOptions"
        item-title="title"
        item-value="value"
        label="Justificativa de reprovação"
        variant="outlined"
        density="compact"
        hide-details
        data-testid="reject-reason-select"
      />

      <v-textarea
        v-model="observation"
        label="Observação (opcional)"
        variant="outlined"
        density="compact"
        rows="3"
        hide-details
        data-testid="reject-observation-input"
      />

      <v-checkbox
        :model-value="requestNewSheet"
        :true-value="true"
        :false-value="false"
        label="Solicitar envio de nova folha"
        density="compact"
        hide-details
        data-testid="reject-request-new-sheet-checkbox"
        @update:model-value="requestNewSheet = $event === true"
      />
    </div>

    <template #footer>
      <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
        <OutlineButton
          text="Cancelar"
          width="96px"
          height="40px"
          data-testid="reject-cancel-button"
          @click="handleClose"
        />
        <FilledButton
          text="Confirmar reprovação"
          class="bg-negative"
          width="200px"
          height="40px"
          :disabled="!selectedReason || saving"
          data-testid="reject-confirm-button"
          @click="handleConfirm"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

const props = defineProps<{
  modelValue: boolean
  saving: boolean
  rejectionReasonOptions: Array<{ title: string; value: string }>
  initialReason?: string | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: [payload: { reason: string; justification?: string; requestNewSheet: boolean }]
}>()

const selectedReason = ref<string | null>(null)
const observation = ref('')
const requestNewSheet = ref(false)

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      selectedReason.value = props.initialReason ?? null
      observation.value = ''
      requestNewSheet.value = false
    }
  }
)

function handleClose() {
  emit('update:modelValue', false)
}

function handleConfirm() {
  if (!selectedReason.value) return
  emit('confirm', {
    reason: selectedReason.value,
    justification: observation.value || undefined,
    requestNewSheet: requestNewSheet.value === true
  })
}
</script>
